module.exports = __webpack_public_path__ + "img/user_d.ecba1844.gif";